import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col, Container, Row, Spinner,
} from 'react-bootstrap';
import { customerStoreReferral } from 'api/api';
import { Constants, validateRegex } from '../../utilities';
import { logBannerClicked } from '../../events/Events';
import CustomModal from './CustomModal';
import Svg from './Svg';

const ReferShop = (props) => {
  const {
    isHome, language, screen, isRevamped,
  } = props;
  const [referShopDetails, setReferShopDetails] = useState({
    storeName: '',
    ownerName: '',
    phoneNumber: '',
    pinCode: '',
  });
  const [referStatus, setReferStatus] = useState('');
  const [referErrorMsg, setReferErrorMsg] = useState('');
  const [showReferModal, setShowReferModal] = useState(false);
  const {
    storeName, ownerName, phoneNumber, pinCode,
  } = referShopDetails;
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (!validateRegex(name, value)) {
      return;
    }
    setReferShopDetails({ ...referShopDetails, [name]: value });
  };
  const onHide = () => {
    setReferStatus('');
    setShowReferModal(false);
    setReferErrorMsg('');
    setReferShopDetails({
      storeName: '',
      ownerName: '',
      phoneNumber: '',
      pinCode: '',
    });
  };
  const submitReferStore = () => {
    setReferStatus('loading');
    setReferErrorMsg('');
    customerStoreReferral(
      'POST',
      {
        storeName,
        ownerName,
        ownerContact: phoneNumber,
        pinCode,
      },
    ).then((res) => {
      if (res.status === 200) {
        onHide();
      } else {
        throw new Error();
      }
    }).catch((err) => {
      let errorMsg = '';
      if (
        err
        && err.response
        && err.response.data
        && err.response.status === 400
        && err.response.data[0].server_message
      ) {
        errorMsg = err.response.data[0].server_message;
      } else {
        errorMsg = Constants.String.OOPS[language];
      }
      setReferErrorMsg(errorMsg);
      setReferStatus('error');
    });
  };

  const ReferShopModalJSX = (
    <Container
      fluid
      className="p-4 border-radius-16 border bg-white"
    >
      <Row
        className="align-items-center"
      >
        <Col
          className="fs-3 font-weight-black"
        >
          Refer a Shop
        </Col>
        <Col
          xs="auto"
        >
          <Button
            variant="link"
            className="m-0 p-0"
            onClick={() => {
              onHide();
            }}
          >
            <Svg
              svg="circleClose"
              width="1rem"
              pathFill="#000000"
              circleFill="#666666"
            />
          </Button>
        </Col>
      </Row>
      <Row
        className="align-items-center"
      >
        <Col
          xs={24}
          className="pt-3"
        >
          <input
            className="form-control fs-0 border-radius-4"
            type="text"
            placeholder="Store Name*"
            name="storeName"
            value={storeName}
            onChange={handleChange}
            maxLength="50"
          />
        </Col>
        <Col
          xs={24}
          className="pt-3"
        >
          <input
            className="form-control fs-0 border-radius-4"
            type="text"
            placeholder="Owner Name*"
            name="ownerName"
            value={ownerName}
            onChange={handleChange}
            maxLength="50"
          />
        </Col>
        <Col
          xs={24}
          className="pt-3"
        >
          <input
            className="form-control fs-0 border-radius-4"
            type="text"
            placeholder="Owner Contact*"
            name="phoneNumber"
            value={phoneNumber}
            onChange={handleChange}
            maxLength="10"
          />
        </Col>
        <Col
          xs={24}
          className="pt-3"
        >
          <input
            className="form-control fs-0 border-radius-4"
            type="text"
            placeholder="Pin Code*"
            name="pinCode"
            value={pinCode}
            onChange={handleChange}
            maxLength="6"
          />
        </Col>
        <Col
          xs={24}
          className="pt-3"
        >
          <Button
            block
            variant="primary"
            className="border-radius-4 d-flex align-items-center justify-content-center"
            onClick={() => {
              submitReferStore();
            }}
            disabled={(
              referStatus === 'loading'
              || !storeName
              || !(phoneNumber.length === 10)
              || !(pinCode.length === 6)
            )}
          >
            {
              referStatus === 'loading' && (
                <div>
                  &nbsp;
                  <Spinner
                    animation="border"
                    variant="light"
                    size="sm"
                  />
                </div>
              )
            }
            {Constants.String.REFER_NOW[language]}
          </Button>
        </Col>
        {
          !!referErrorMsg && (
            <Col
              xs={24}
              className="pt-1 text-center text-danger"
            >
              {referErrorMsg}
            </Col>
          )
        }
      </Row>
    </Container>
  );
  return (
    <Col
      xs={isHome ? true : 24}
      md={isHome ? true : 12}
      className={`"p-2" ${isRevamped ? 'r__refer_shop' : ''}`}
    >
      <CustomModal
        show={showReferModal}
        size="md"
        backdrop
        shadow
        onHide={() => {
          onHide();
        }}
        body={(ReferShopModalJSX)}
      />
      <Container
        variant="link"
        id="refer-shop-card"
        className="mx-0 p-0 h-100 border border-radius-8 overflow-hidden cursor-pointer"
        onClick={() => {
          logBannerClicked(
            {
              Page: screen,
              Name: 'Shop Refer In Platfrom',
            },
          );
          setShowReferModal(true);
        }}
      >
        <Row
          className="mx-0 justify-content-between"
        >
          <Col
            xs={isHome ? 16 : 17}
            sm={isHome ? 16 : 18}
            md={isHome ? 15 : 16}
            lg={isHome ? 15 : 17}
            className="pl-3 pt-3 pb-3 pr-1"
          >
            <h2
              className="mb-1 text-primary text-wrap"
            >
              {Constants.String.REFER_LOCAL_SHOPS[language]}
            </h2>
            <h4
              className="mb-3 text-violet text-wrap"
            >
              {Constants.String.FROM_YOUR_NEIGHBOURHOOD[language]}
            </h4>
            <div>
              <span
                className="d-inline-block py-2 px-3 bg-violet rounded text-white fs-6"
              >
                {Constants.String.REFER_NOW[language].toUpperCase()}
              </span>
            </div>
          </Col>
          <Col
            xs={isHome ? 8 : 7}
            sm={isHome ? 8 : 6}
            md={isHome ? 9 : 8}
            lg={isHome ? 9 : 7}
            className="p-0 h-100"
          >
            <img
              src="/images/shopkeeper.png"
              alt=""
              className="w-100 mh-100"
            />
          </Col>
        </Row>
      </Container>
    </Col>
  );
};

ReferShop.propTypes = {
  isHome: PropTypes.bool,
  isRevamped: PropTypes.bool,
  language: PropTypes.string.isRequired,
  screen: PropTypes.string.isRequired,
};

ReferShop.defaultProps = {
  isHome: false,
  isRevamped: false,
};

export default ReferShop;
